import type { Level } from '@/features/journeys'
import type { LevelProgress } from '@/shared/types/user-progress'

export type LevelPlayState =
  | { kind: 'loading' }
  | { kind: 'ready' }
  | { kind: 'level_unavailable'; title: string; description: string }
  | { kind: 'level_redo_blocked'; title: string; description: string }
  | { kind: 'level_blocked'; title: string; description: string }
  | { kind: 'empty_challenges'; title: string; description: string }
  | { kind: 'empty_steps'; title: string; description: string }
  | { kind: 'challenge_unavailable'; title: string; description: string }

type Params = {
  isLoading: boolean
  level: Level | null
  levelProgress: LevelProgress | null
  redoBlocked: boolean
  stepsCount: number
}

export function getLevelPlayState({
  isLoading,
  level,
  levelProgress,
  redoBlocked,
  stepsCount
}: Params): LevelPlayState {
  if (isLoading) return { kind: 'loading' }

  if (!level) {
    return {
      kind: 'level_unavailable',
      title: 'Este nível não está disponível agora',
      description:
        'Não foi possível carregar o nível solicitado no momento. Você pode voltar e escolher outro.'
    }
  }

  if (redoBlocked) {
    return {
      kind: 'level_redo_blocked',
      title: 'Você já concluiu este nível',
      description:
        'Esta jornada não permite refazer conteúdos já concluídos.'
    }
  }

  if (levelProgress?.blocked) {
    return {
      kind: 'level_blocked',
      title: 'Este nível ainda está bloqueado',
      description:
        'Complete os requisitos deste conteúdo e tente novamente em seguida.'
    }
  }

  if ((level.active_challenges?.length ?? 0) === 0) {
    return {
      kind: 'empty_challenges',
      title: 'Este nível ainda não tem desafios disponíveis',
      description:
        'O conteúdo deste nível ainda está sendo preparado. Volte para escolher outro.'
    }
  }

  if (stepsCount === 0) {
    return {
      kind: 'empty_steps',
      title: 'Não foi possível iniciar este nível',
      description:
        'Não encontramos as etapas necessárias para este conteúdo. Tente outro nível.'
    }
  }

  return { kind: 'ready' }
}
